import { tracking } from '@iwoca/frontend-tracking-library';
import { fork, takeLatest } from 'redux-saga/effects';

import { ACTIVATE_TRUELAYER, FETCH_TRUELAYER_URL } from './TrueLayer.actions';
import { GET_TRUELAYER_URL } from '../../lendingAPI/lendingAPI.actions';
import { putAPI } from '../../lendingAPI/lendingAPIHelpers';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';

export default [fork(trueLayerViewWorker), fork(fetchTruelayerURLWorker)];

function* trueLayerViewWorker() {
    yield takeLatest(ACTIVATE_TRUELAYER, function* () {
        try {
            yield putAPI({ type: `api/${GET_TRUELAYER_URL}` });
        } catch (error) {
            console.log(error);
        }
    });
}

function* fetchTruelayerURLWorker() {
    yield takeLatest(FETCH_TRUELAYER_URL, function* () {
        try {
            const response = yield putAPI({ type: `api/${GET_TRUELAYER_URL}` });

            // If successful, redirect user
            if (response.type === 'api/GET_TRUELAYER_URL [success]') {
                tracking.ampli
                    .openBankingConnectStarted({
                        ...getAmplitudeDefaultEventProperties()
                    })
                    .promise.finally(() => {
                        window.location.href =
                            response.payload.authorization_url;
                    })
                    .catch(() => {
                        console.error(
                            'Amplitude openBankingConnectStarted Error'
                        );
                    });
            }
        } catch (error) {
            console.log(error);
        }
    });
}
